var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningBoltBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 3.60001,
    x2: 24.5355,
    y1: 1.19971,
    y2: 17.4828
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1475,
    stopColor: "#72c4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4325fa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.5608 1.25531c.4995.15746.8392.62072.8392 1.14448v6h4.8c.4475 0 .8577.24895 1.0644.64583.2066.39688.1753.87576-.0813 1.24228l-8.4 12c-.3004.4291-.8443.6138-1.3439.4564-.49949-.1575-.83919-.6207-.83919-1.1445v-6h-4.8c-.44745 0-.85774-.249-1.06437-.6458-.20664-.3969-.1753-.8758.08129-1.2424l8.39997-11.99996c.3004-.42909.8443-.6138 1.3439-.45633z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningBoltBlue);
export default __webpack_public_path__ + "static/media/lightning-bolt-blue.f03455413bc34bd0dbcf69b078a21738.svg";
export { ForwardRef as ReactComponent };